// components
import ComponentsRender from '@/components/ComponentsRender';

// constants
import { COMPONENTS } from '@/components/components';

const DynamicBlock = ({ content }) => {
  return (
    <>
      {(content || []).map((component) => (
        <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
      ))}
    </>
  );
};
export default DynamicBlock;
